import React from "react";
import { useLenis } from "@/hooks/useLenis";
import { AnimatedBackground } from "@/components/AnimatedBackground";
import { ScrollProgress } from "@/components/ScrollProgress";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { TrustBar } from "@/components/TrustBar";
import { Pillars } from "@/components/Pillars";
import { IndustryFocus } from "@/components/IndustryFocus";
import { VillaCoverage } from "@/components/villa/VillaCoverage";
import { Partners } from "@/components/Partners";
import { HotelClients } from "@/components/HotelClients";
import { Locations } from "@/components/Locations";
import { Footer } from "@/components/Footer";
import { ContactDock } from "@/components/ContactDock";
import { ClientMarquee } from "@/components/ClientMarquee";
import { ContactPerson } from "@/components/ContactPerson";

export default function Home() {
  useLenis();
  return (
    <div className="relative pb-[68px] md:pb-0" data-testid="home-page">
      <AnimatedBackground />
      <ScrollProgress />
      <Navbar />
      <main>
        <Hero />
        <ClientMarquee />
        <TrustBar />
        <VillaCoverage />
        <Pillars />
        <ContactPerson />
        <IndustryFocus />
        <Partners />
        <HotelClients />
        <Locations />
      </main>
      <Footer />
      <ContactDock />
    </div>
  );
}
